const apiURL = "https://v4-supportportal-api.learn360lms.com/";
export const USER_LOGIN = `account/login`;
export const ALL_TENANTS = `getAllTenants`;
export const GET_USER_DATA = `getUserDataByTenantID`;
export const GET_COURSE_DATA = `getProductDetails`;
export const GET_USER_LOGS = `getUserLogs`;
export const GET_USER_SUBSCRIPTION_LOGS = `getUserSubscriptionLogs`;
export const GET_USER_SUBSCRIPTION_DETAIL_LOGS = `getSubscriptionLogsDetail`;
export const RESET_USER = `resetUserDevice`;
export const EXPORT_ATTENDANCE_REPORT = `getUserAttendanceReport`;
export const ENROLL_COURSE = `enrollCourse`;
export default apiURL;